// `orders.created` / `orders.updated` on `venue:{id}:orders` (spec/09 §3, §6.3; F-POS-15). The console's Orders
// screen stays live: a sale placed anywhere at the venue — at the counter, or at a PC's kiosk (a food order or a
// pass, F-KIO-10) — is announced as `orders.created`, and one paid or cancelled as `orders.updated`.
//
// A frame carries the sale's id and where it now is, not the sale: the console re-reads its list (and the open
// drawer) from REST, which stays the recovery mechanism (spec/09 §4), so a dropped frame converges on the next
// read. A member subscribes to `venue:{id}:orders` only with `orders:read`, the permission the Orders list takes
// (the gateway checks it, spec/09 §3). The frames ride the outbox dispatcher's realtime sink
// (`commerce/realtime.ts`), like the kitchen's. The station client (C#) does not read these.
import { z } from "../zod.js";
import { SaleIdSchema } from "../ids/schema.js";
import { ORDERS_CREATED, ORDERS_UPDATED } from "./constants.js";
import { realtimeMessage } from "./envelope.js";
export { ORDERS_CREATED, ORDERS_UPDATED };
/** What either frame carries: the sale and where it is now (`placed` | `paid` | `cancelled`). */
export const OrdersEventPayloadSchema = z
    .object({
    saleId: SaleIdSchema,
    status: z.enum(['placed', 'paid', 'cancelled']),
})
    .openapi('OrdersEventPayload', { description: 'A sale at the venue was placed, paid or cancelled (spec/09 §6.3).' });
/** A sale was placed at the venue (F-POS-15). */
export const OrdersCreatedMessage = realtimeMessage('evt', ORDERS_CREATED, OrdersEventPayloadSchema);
/** A sale at the venue was paid or cancelled (F-POS-15). */
export const OrdersUpdatedMessage = realtimeMessage('evt', ORDERS_UPDATED, OrdersEventPayloadSchema);
//# sourceMappingURL=orders.js.map